import { ACTION } from "./constants";
import request from "../../../../utils/request";
import { requestConfig } from "../../../../config/apiResource";
import { showMainLoader, hideMainLoader } from "../../../actions";
import { formDataGenerator } from "../../../../utils/common";

export function getstatutoryList(formData) {
  return (dispatch) => {
    return request(requestConfig.getstatutoryList(formData))
      .then((json) => {
        json && dispatch({ type: ACTION.STATUTORY_LIST, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with statutory list data: " + error);
      });
  };
}

export function getnewStatutoryContent(serverData, formData, pageType) {
  let formDataValue, typeDataValue, data;
  if (serverData.url) {
    let urlArray = serverData.url.split("/"),
      type = urlArray[urlArray.length - 1];

    if (type == "annual-reports") {
      typeDataValue = "annual";
    } else if (type == "average-portfolio") {
      typeDataValue = "portfolio";
    } else if (
      type == "details-deviations-valuation-price-provided-valuation-agencies"
    ) {
      typeDataValue = "valuation";
    } else if (type == "mandatory-investment-amc") {
      typeDataValue = "mandatory-investment";
    } else if (type == "stewardship-report") {
      typeDataValue = "stewardship";
    } else if (type == "offer-document-disclosures") {
      typeDataValue = "offer-document";
    } else if (type == "aum") {
      typeDataValue = "aum";
    } else if (type == "statutory-disclosure-hdfc-mid-cap-opportunities-fund-and-hdfc-small-cap-fund") {
      typeDataValue = "risk-parameters";
    } else if (type == "market-makers-authorized-participants") {
      typeDataValue = "market-makers";
    } else if (type == "disclosure-of-issuerwise-groupwise-sectorwise-exposure-for-etf-index-funds") {
      typeDataValue = "passive-fund-etf";
    } else if (type == "information-ratio-disclosure-for-equity-mutual-funds"){
      typeDataValue = "daily-performance-IR";
    } else {
      typeDataValue = type;
    }

    if(type == "aum"){
      data = {
        disclosuresPage: typeDataValue,
        frequency: "quarterly",
      };
    }
    else{
      data = {
        disclosuresPage: typeDataValue,
        frequency: "avg",
        search: "",
        limit: 10,
        offset: 0,
        year: "",
      };
    }
    formDataValue = formDataGenerator(data);
  } else {
    formDataValue = formData;
    typeDataValue = pageType;
  }

  return (dispatch) => {
    return request(
      requestConfig.getnewStatutoryContent(formDataValue, typeDataValue)
    )
      .then((json) => {
        if (typeDataValue == "riskometers") {
          json &&
            dispatch({ type: ACTION.STATUTORY_RISKOMETER, data: json.data });
        } else if (typeDataValue == "valuation") {
          json &&
            dispatch({ type: ACTION.STATUTORY_VALUATION, data: json.data });
        } else if (typeDataValue == "scheme-financials") {
          json &&
            dispatch({
              type: ACTION.STATUTORY_SCHEME_FINANCE,
              data: json.data,
            });
        } else if (typeDataValue == "commission") {
          json &&
            dispatch({ type: ACTION.STATUTORY_COMMISSION, data: json.data });
        } else if (typeDataValue == "aum") {
          json && dispatch({ type: ACTION.STATUTORY_AUM, data: json.data });
        } else if (typeDataValue == "voting") {
          json && dispatch({ type: ACTION.STATUTORY_VOTING, data: json.data });
        } else if (typeDataValue == "abridged") {
          json &&
            dispatch({ type: ACTION.STATUTORY_ABRIDGED, data: json.data });
        } else if (typeDataValue == "portfolio") {
          json &&
            dispatch({
              type: ACTION.STATUTORY_AVERAGE_PORTFOLIO,
              data: json.data,
            });
        } else if (typeDataValue == "mandatory-investment") {
          json &&
            dispatch({ type: ACTION.MANDATORY_INVESTMENT, data: json.data });
        } else if (typeDataValue == "trade") {
          json && dispatch({ type: ACTION.STATUTORY_TRADE, data: json.data });
        } else if (typeDataValue == "tracking-error") {
          json &&
            dispatch({
              type: ACTION.STATUTORY_TRACKING_ERROR,
              data: json.data,
            });
        } else if (typeDataValue == "annual") {
          json &&
            dispatch({ type: ACTION.STATUTORY_ANNUAL_REPORT, data: json.data });
        } else if (typeDataValue == "stewardship") {
          json &&
            dispatch({ type: ACTION.STATUTORY_STEWARDSHIP, data: json.data });
        } else if (typeDataValue == "scheme-performance") {
          json &&
            dispatch({
              type: ACTION.STATUTORY_SCHEME_PERFORMANCE,
              data: json.data,
            });
        } else if (typeDataValue == "letter-unitholder") {
          json &&
            dispatch({ type: ACTION.LETTER_UNIT_HOLDER, data: json.data });
        } else if (typeDataValue == "complaints") {
          json &&
            dispatch({ type: ACTION.SATURITY_COMPLAINTS, data: json.data });
        } else if (typeDataValue == "data-on-investor-complaints") {
          json &&
            dispatch({
              type: ACTION.STATUTORY_INVESTOR_COMPLAINTS,
              data: json.data,
            });
        } else if (typeDataValue == "investor-complaints-pms") {
          json &&
            dispatch({ type: ACTION.STATUTORY_INVESTOR_COMPLAINTS_PMS, data: json.data });
        } else if (typeDataValue == "offer-document") {
          json &&
            dispatch({
              type: ACTION.OFFER_DOCUMENTS,
              data: json.data,
            });
        } else if (typeDataValue == "risk-parameters") {
          json &&
            dispatch({
              type: ACTION.STATUTORY_RISK_DISCLOSURES,
              data: json.data,
            });
        } else if (pageType == "disclosure-on-distributor-related-expenses") {
          json &&
            dispatch({ type: ACTION.DISTRIBUTOR_RELATED_EXPENSES, 
              data: json.data 
            });
        } else if (typeDataValue == "market-makers") {
          json &&
            dispatch({
              type: ACTION.MARKET_MAKER_PAGE,
              data: json.data,
            });
        } else if (typeDataValue == "passive-fund-etf") {
          json &&
            dispatch({
              type: ACTION.PASSIVE_FUND_ETF,
              data: json.data,
            });
        } else if (typeDataValue == "daily-performance-IR") {
          json &&
            dispatch({ type: ACTION.DAILY_PERFORMANCE_IR, data: json.data });
        } else if (typeDataValue == "report-misselling") {
          json &&
          dispatch({ type: ACTION.STATUTORY_REPORT_MISSELLING_FUND, data: json.data });
        }
        return json;
      })
      .catch((error) => {
        console.log("Got Error with statutory list data: " + error);
      });
  };
}

export function getEmployeeCompensationsaturity(formData) {
  return (dispatch) => {
    return request(requestConfig.getEmployeeCompensationsaturity(formData))
      .then((json) => {
        json &&
          dispatch({
            type: ACTION.GET_DESIGNATED_EMPLOYEE_DATA_NEW,
            data: json.data,
          });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with GET_DESIGNATED_EMPLOYEE" + error);
      });
  };
}
export function getEmployeeCompensationSearchsaturity(formData) {
  return (dispatch) => {
    return request(
      requestConfig.getEmployeeCompensationSearchsaturity(formData)
    )
      .then((json) => {
        json &&
          dispatch({
            type: ACTION.GET_DESIGNATED_EMPLOYEE_DATA_NEW,
            data: json.data,
          });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with GET_DESIGNATED_EMPLOYEE_SEARCH " + error);
      });
  };
}

export function getStatutoryFilterNewPortfolio(serverData,formData, filterType) {

  let formDataValue,typeDataValue;
  if (serverData.url) {
    let urlArray = serverData.url.split("/"),
    type = urlArray[urlArray.length - 1];
    let data = {
      year: "",
      type: type == 'monthly-portfolio' ? 'monthly':'fortnightly',
      month: ""
    };
    formDataValue = formDataGenerator(data);
    typeDataValue = 'monthfortportfolio';
  } else {
    formDataValue = formData;
    typeDataValue = filterType;
  }

  return (dispatch) => {
    return request(requestConfig.getStatutoryFilterNew(formDataValue, typeDataValue))
      .then((json) => {
        typeDataValue == "monthfortportfolio" &&
          json &&
          dispatch({
            type: ACTION.STATUTORY_MONTH_YEAR_PORTFOLIO,
            data: json.data,
          });
        typeDataValue == "portfolioMonths" &&
          json &&
          dispatch({ type: ACTION.STATUTORY_PORTFOLIO_MONTH, data: json.data });
        typeDataValue == "search" &&
          json &&
          dispatch({ type: ACTION.STATUTORY_SEARCH, data: json.data });

        return json;

      })
      .catch((error) => {
        console.log("Got Error with statutory filter content " + error);
      });
  };
}
export function getStatutoryFilterNew(formData, filterType) {
  return (dispatch) => {
    return request(requestConfig.getStatutoryFilterNew(formData, filterType))
      .then((json) => {
        filterType == "disclosuresSubReportFilter" &&
          json &&
          dispatch({ type: ACTION.STATUTORY_ABRIDGE_FILLTER, data: json.data });
        filterType == "disclosuresMonthsFilter" &&
          json &&
          dispatch({ type: ACTION.STATUTORY_MONTHS_FILLTER, data: json.data });

        return json;
      })
      .catch((error) => {
        console.log("Got Error with statutory filter content " + error);
      });
  };
} 

export function cleargetStatutoryFilterNew() {
  return (dispatch) => {
    dispatch({ type: ACTION.STATUTORY_MONTHS_FILLTER, data: [] })
  };
}

export function getTerNewCommon() {
  return (dispatch) => {
    return request(requestConfig.getTerNew())
      .then((json) => {
        json && dispatch({ type: ACTION.GET_TER_NEW_COMMON, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with ter common" + error);
      });
  };
}

export function getTerNoticeContent(formData) {
  return (dispatch) => {
    return request(requestConfig.getTerNoticeContentNew(formData))
      .then((json) => {
        json &&
          dispatch({ type: ACTION.GET_TER_NOTICE_CONTENT, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with notice" + error);
      });
  };
}
export function getTerReportContent(formData) {
  return (dispatch) => {
    return request(requestConfig.getTerReportContentNew(formData))
      .then((json) => {
        json && dispatch({ type: ACTION.GET_TER_REPORT, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with ter report" + error);
      });
  };
}
export function getTerReportMonthFilter(formData) {
  return (dispatch) => {
    return request(requestConfig.getTerReportMonthFilterNew(formData))
      .then((json) => {
        json && dispatch({ type: ACTION.GET_TER_MONTH, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with ter report month" + error);
      });
  };
}

export function getRemunerationContentNew() {
  return (dispatch) => {
    return request(requestConfig.getRemunerationContentNew())
      .then((json) => {
        json &&
          dispatch({ type: ACTION.GET_REMUNERATION_CONTENT, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with Remuneration content " + error);
      });
  };
}
export function getPublicCautiondata() {
  return (dispatch) => {
    return request(requestConfig.getPublicCautionDataNew())
      .then((json) => {
        json &&
          dispatch({ type: ACTION.PUBLIC_CAUTION_NOTICE_NEW, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with Public Caution Notice content " + error);
      });
  };
}
export function getPassiveFundMonthFilterNew(formData) {
  return (dispatch) => {
    return request(requestConfig.getPassiveFundMonthFilterNew(formData))
      .then((json) => {
        json && dispatch({ type: ACTION.STATUTORY_PASSIVE_FUND_MONTH, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with passive fund month" + error);
      });
  };
}
